<h2 mat-dialog-title>Warning</h2>
<mat-dialog-content>
  <div>You are about to leave the wizard. Would you like to save your session to continue later?</div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="w-100 flex-row justify-end items-center mt-3 p-2 wizard-exit-actions">
    <a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancel()"><span class="text-bold">CANCEL</span></a>
    <a mat-button class="dialog-btn mr-5" color="warn" (click)="onDelete()"><span class="text-bold">DELETE</span></a>
    <a mat-raised-button class="dialog-btn" color="primary" (click)="onSave()"><span class="text-bold">SAVE</span></a>
  </div>
</mat-dialog-actions>
